export default "__VITE_ASSET__BvV9ugRe__"